import { atom } from 'recoil';
import { ISolicitacao } from '../../commons/types/solicitacoes';

export const solicitacoesAtom = atom<ISolicitacao[]>({
  key: 'solicitacoes', 
  default: [] as ISolicitacao[],
});

export const solicitacaoAtualAtom = atom<ISolicitacao | null>({
  key: 'solicitacaoAtual',
  default: null,
});
